import withModerationStatusDetails from './withModerationStatusDetails'
import MediaThumbnailTitle from 'components/MediaThumbnailTitle'

export default withModerationStatusDetails(MediaThumbnailTitle)
